// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  configFireBase : {
    apiKey: "AIzaSyAH7pIPGC-MmbZYzRTF0RTYS68Nezbn8oc",
    authDomain: "vridez-dcf77.firebaseapp.com",
    databaseURL: "https://vridez-dcf77.firebaseio.com",
    projectId: "vridez-dcf77",
    storageBucket: "",
    messagingSenderId: "915499399345",
    appId: "1:915499399345:web:671ef1e58668ea01acca90"
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
